<template>
  <div class="table-wrapper">
    <table class="table_bordered">
      <thead>
      <tr v-if="isFlatHeader">
        <th
            v-for="(col, colIndex) in parsedColumns[0]"
            :key="colIndex"
            :rowspan="col.rowspan || null"
            :colspan="col.colspan || null"
            v-html="col.title"
        />
      </tr>
      <template v-else>
        <tr v-for="(row, rowIndex) in parsedColumns" :key="rowIndex">
          <th
              v-for="(col, colIndex) in row"
              :key="colIndex"
              :rowspan="col.rowspan || null"
              :colspan="col.colspan || null"
              v-html="col.title"
          />
        </tr>
      </template>
      </thead>
      <tbody>
      <tr v-for="(row, rowIndex) in parsedRows" :key="rowIndex">
        <td v-for="(cell, colIndex) in row" :key="colIndex" v-html="cell" />
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'ContentTable',
  props: {
    columns: {
      type: Array,
      required: true
    },
    rows: {
      type: Array,
      required: true
    }
  },
  computed: {
    isFlatHeader() {
      return this.columns.length && !Array.isArray(this.columns[0]);
    },
    parsedColumns() {
      const source = this.isFlatHeader ? [this.columns] : this.columns;

      return source.map(row =>
          row.map(col =>
              typeof col === 'string'
                  ? { title: col }
                  : {
                    title: col.title || '',
                    rowspan: col.rowspan || null,
                    colspan: col.colspan || null
                  }
          )
      );
    },
    parsedRows() {
      return this.rows.map(row =>
          Array.isArray(row)
              ? row
              : typeof row === 'object'
                  ? Object.values(row)
                  : [row]
      );
    }
  }
};
</script>